var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-mist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-mist",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,18 C22.3284271,18 23,18.6715729 23,19.5 C23,20.3284271 22.3284271,21 21.5,21 L9.5,21 C8.67157288,21 8,20.3284271 8,19.5 C8,18.6715729 8.67157288,18 9.5,18 L21.5,18 Z M15.5,13 C16.3284271,13 17,13.6715729 17,14.5 C17,15.3284271 16.3284271,16 15.5,16 L5.5,16 C4.67157288,16 4,15.3284271 4,14.5 C4,13.6715729 4.67157288,13 5.5,13 L15.5,13 Z M20.5,8 C21.3284271,8 22,8.67157288 22,9.5 C22,10.3284271 21.3284271,11 20.5,11 L3.5,11 C2.67157288,11 2,10.3284271 2,9.5 C2,8.67157288 2.67157288,8 3.5,8 L20.5,8 Z M20.5,3 C21.3284271,3 22,3.67157288 22,4.5 C22,5.32842712 21.3284271,6 20.5,6 L10.5,6 C9.67157288,6 9,5.32842712 9,4.5 C9,3.67157288 9.67157288,3 10.5,3 L20.5,3 Z",
    id: "Combined-Shape",
    fill: "#44484C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMist);
export default __webpack_public_path__ + "static/media/ico-mist.7a1c32896b6443698ce97dc184a8ec52.svg";
export { ForwardRef as ReactComponent };